import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

const FilterMobileToggle = styled.div.attrs({
  'data-test': 'FilterMobileToggle',
})`
  display: none;
  margin-bottom: ${layout.margins.component.mobile.rem};

  ${media.mediumDown`
    display: block;
  `};
`;

export { FilterMobileToggle };
